import React from 'react';
import classNames from 'classnames';
import { Button, Sprite } from '@agissc/ktag-map';
import useAppState from '../../AppStore';
import { ToolNames } from '../../tools/ToolNames';

const MapContentButton = () => {
  const isToolbarOpen = useAppState((state) => state.toolbar.isOpen);
  const toggleToolbar = useAppState((state) => state.toggleToolbar);
  const activeTool = useAppState((state) => state.activeTool);
  const setActiveTool = useAppState((state) => state.setActiveTool);
  const counterTopicLayers = useAppState((state) => state.selectedTopicLayers);
  const badge = counterTopicLayers.length;
  const isActiveTool = activeTool === ToolNames.layerSelection;

  const onClick = () => {
    if (isActiveTool) setActiveTool(ToolNames.identify);
    else setActiveTool(ToolNames.layerSelection, 'mapContent_tool_main');
    if (isToolbarOpen) toggleToolbar();
  };

  return (
    <Button additionalClassNames="mobile-button" onClick={onClick}>
      <Sprite
        additionalClassNames={isActiveTool ? 'mobile-button--active' : ''}
        id="layers"
      />
      {badge > 0 && (
        <span
          className={classNames('mobile-button__badge', {
            'mobile-button__badge--active': isActiveTool,
          })}
        >
          {badge}
        </span>
      )}
    </Button>
  );
};

export default MapContentButton;
